// import * as Turbo from "@hotwired/turbo";
import simpleParallax from "simple-parallax-js";
import AOS from "aos";

const AOSOptions = {
  offset: 50,
  delay: 150,
  duration: 800,
};
const aosDefaultEffect = "fade-up";

function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function onWindowScroll(ev) {
  if (window.scrollY) {
    document
      .querySelector("body")
      .classList.add("scroll-down-beyond-threshold");
  } else {
    document
      .querySelector("body")
      .classList.remove("scroll-down-beyond-threshold");
  }
}

window.addEventListener("keydown", (ev) => {
  if (ev.key === "d" && document.querySelector(".admin-panel")) {
    document.querySelector("body").classList.toggle("debug");
  }
});

document.addEventListener(
  window.Turbo ? "turbo:load" : "DOMContentLoaded",
  function (event) {
    ["click"].forEach((eventName) =>
      document.querySelector(".toggle-mobile-navigation").addEventListener(
        eventName,
        (ev) => {
          ev.target.classList.toggle("active");
          document
            .querySelector("body")
            .classList.toggle("mobile-menu-exanded");
        },
        false
      )
    );

    document.querySelectorAll("section.grid[data-href]").forEach((el) => {
      el.addEventListener(
        "click",
        (ev) => {
          window.location = el.dataset.href;
        },
        false
      );
    });

    document
      .querySelectorAll(`article > header > .content a:not([href^="tel"])`)
      .forEach((a) => {
        a.classList.add("underline");
      });

    [
      ...document.querySelectorAll(
        [
          "main .columns > .column h1",
          "main .columns > .column h2",
          "main .columns > .column h3",
          "main .columns > .column h4",
          "main .columns > .column h5",
          "main .columns > .column p",
          "main .columns > .column h6",
          "main .columns > .column a",
          "main .block-image img",
        ].join(", ")
      ),
    ].forEach((el) => {
      if (!el.closest('.no-fade-in-effect')) {
        el.dataset.aos = aosDefaultEffect;
      }
    });
    AOS.init(AOSOptions);

    if (isTouchDevice()) {
      return;
    }

    /**
     * desktop only
     */

    document.querySelectorAll("img.parallax").forEach((img) => {
      new simpleParallax(img, {
        // scale: 1.2,
        // maxTransition: 99
      });
    });

    document
      .querySelectorAll(".block-gallery, .block-projectsGallery")
      .forEach((div) => {
        function scrollToElement(container, li) {
          const { width } = container.getBoundingClientRect();
          const scrollElement = div.querySelector("ul");
          div
            .querySelectorAll("li")
            .forEach((li) => li.classList.remove("current"));
          li.classList.add("current");
          console.log(li.offsetLeft);
          scrollElement.scrollTo({
            top: 0,
            left: li.offsetLeft - width * 2 + 1,
            behavior: "smooth",
          });
        }

        // let ul = div.querySelector("ul");

        if (false) {
          // not working
          div.querySelectorAll("li").forEach((li) => {
            new IntersectionObserver(
              (entries, observer) => {
                setTimeout(() => {
                  let centeredEntry = entries.filter(
                    (entry) => entry.intersectionRatio === 1
                  );
                  if (centeredEntry[0]) {
                    div
                      .querySelectorAll("li")
                      .forEach((e) => e.classList.remove("current"));
                    centeredEntry[0].target.classList.add("current");
                  }
                }, 100);
              },
              {
                threshold: 1,
              }
            ).observe(li);
          });
        }

        div.querySelectorAll("li").forEach((li) => {
          li.addEventListener("click", (ev) => {
            if (!ev.target.classList.contains("see-project")) {
              ev.preventDefault();
            }
            scrollToElement(ev.target, li);
          });
        });

        if (div.querySelectorAll("li").length > 1) {
          // select 2nd
          div.querySelectorAll("li")[1].click();
        }
      });

    document.querySelectorAll("nav.menu a").forEach((a) => {
      //getAttribute('aria-current')
      a.setAttribute(
        "aria-current",
        window.location.href === a.href ? "page" : ""
      );
    });
  }
);

window.addEventListener("scroll", onWindowScroll, false);
